/* eslint-disable no-redeclare */

import { z } from 'zod';

import { HealthcareSessionId } from '../primitive/healthcare-session-id';
import { HealthcareUserId } from '../primitive/healthcare-user-id';

export const HealthCareIdentifier = z.object({
  sessionId: HealthcareSessionId,
  userId: HealthcareUserId,
});

export type HealthCareIdentifier = z.infer<typeof HealthCareIdentifier>;
